/* eslint-disable perfectionist/sort-enums */

export enum PAGE_LOAD_TYPE {
  FOREGROUND = 1,
  BACKGROUND = 2,
}

/* eslint-enable perfectionist/sort-enums */
